module.exports = __webpack_public_path__ + "static/media/shutterstock_172135856_0009_010.39e5f25c.png";